export default "__VITE_ASSET__c114b7b8__"